import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

function srcset(image, size, rows = 1, cols = 1) {
  return {
    src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
    srcSet: `${image}?w=${size * cols}&h=${
      size * rows
    }&fit=crop&auto=format&dpr=2 2x`,
  };
}

export default function GalleryList() {
  return (
    <ImageList
      variant="quilted"
      cols={4}
      rowHeight={121}
    >
      {itemData.map((item) => (
        <ImageListItem key={item.img} cols={item.cols || 1} rows={item.rows || 1}>
          <img
            {...srcset(item.img, 121, item.rows, item.cols)}
            alt={item.title}
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

const itemData = [
  {
    img: '/images/login/Owner_With_car1.webp',
    title: 'Owner with car image',
    rows: 2,
    cols: 2,
  },
  {
    img: '/images/login/VisitingCard2.webp',
    title: 'SVR Taxi visiting card',
    rows:1,
    cols:2,
  },
  {
    img: '/images/login/toyoto_black_front.jpg',
    title: 'Toyoto black 8 seater available for taxi service in svr taxi service',
    rows:1,
    cols:2,
  },
  {
    img: '/images/login/TharaiTravels.webp',
    title: 'Toyoto black color 8 seater available for taxi service in svr taxi',
    cols: 1,
    rows:2,
  },
  {
    img: '/images/login/mini_omini.webp',
    title: 'Hats',
    cols: 3,
    rows:2,
  },
  {
    img: '/images/login/palani_trip_toyoto_5.webp',
    title: 'Palani trip available photo in svr taxi',
    rows: 2,
    cols: 4,
  },
  {
    img: '/images/login/Wedding-Car.webp',
    title: 'for wedding also car service is available in svr taxi located in salem',
    rows:2,
    cols:2,
  },
  {
    img: '/images/login/icon-generating.webp',
    title: 'SVR Taxi logo image',
    rows:2,
    cols:2
  },
  ];
